//constants
import Vue from 'vue'
import smoothscroll from 'smoothscroll-polyfill'
const VueAwesomeSwiper           = require('vue-awesome-swiper')
const VueScrollTo                = require('vue-scrollto')
// const VueCookies                 = require('vue-cookies')
const VUE_COMMON                 = require("./lib/commonVueOperation.js")
const PAGE_TOP                   = require("./pages/page_top.js")
const PAGE_FAQ                   = require("./pages/page_faq.js")
const PAGE_USEFUL                = require("./pages/page_useful.js")
const PAGE_WORK                  = require("./pages/page_work.js")
const PAGE_WORK_DETAIL           = require("./pages/page_work_detail.js")
const PAGE_GRAPH                 = require("./pages/page_graph.js")
const PAGE_PREDICTION            = require("./pages/page_prediction.js")


const PAGE_NEWS                  = require("./pages/page_news.js")
const PAGE_NEWS_DETAIL           = require("./pages/page_news_detail.js")
const axios = require("axios").default

import NEXCO_CONFIG from 'NEXCO_CONFIG';


let pages = [
  {path:"^/2021_chugoku/$|^/2021_chugoku/index\.html$", entry: [pageTop]},
  {path:"^/2021_chugoku/detour/$|^/2021_chugoku/detour/index\.html$", entry: [pageStatic]},
  {path:"^/2021_chugoku/prediction/graph/$|^/2021_chugoku/prediction/graph/index\.html$", entry: [pageGraph]},
  {path:"^/2021_chugoku/prediction/$|^/2021_chugoku/prediction/index\.html$", entry: [pagePrediction]},
  {path:"^/2021_chugoku/price/$|^/2021_chugoku/price/index\.html$", entry: [pageStatic]},
  {path:"^/2021_chugoku/faq/$|^/2021_chugoku/faq/index\.html$", entry: [pageFaq]},
  {path:"^/2021_chugoku/useful/$|^/2021_chugoku/useful/index\.html$", entry: [pageUseful]},
  {path:"^/2021_chugoku/ad/$|^/2021_chugoku/ad/index\.html$", entry: [pageStatic]},
  {path:"^/2021_chugoku/radar2/$|^/2021_chugoku/radar2/kansai\.html$", entry: [pageStatic]},
  {path:"^/2021_chugoku/work/$|^/2021_chugoku/work/index\.html$|^/2021_chugoku/work/progress/$|^/2021_chugoku/work/progress/index\.html$", entry: [pageWork]},
  {path:"^/2021_chugoku/work/progress/article/$|^/2021_chugoku/work/progress/article/index\.html$", entry: [pageWorkDetail]},
  {path:"^/2021_chugoku/cp/$|^/2021_chugoku/cp/index\.html$", entry: [pageStatic]},
  {path:"^/2021_chugoku/news/$|^/2021_chugoku/news/index\.html$", entry: [pageNews]},
  {path:"^/2021_chugoku/news/article/$|^/2021_chugoku/news/article/index\.html$", entry: [pageNewsDetail]},
]

//---------
//Vue base setup
//インフォメーション
var informations = []
var news = []
axios.get('/2021_chugoku/cms/information.json').then( (res) => {
  informations = res.data;
  // console.log(informations)

  informations.forEach( (info) => {
    var isNews = false
    Object.keys(info.categories).forEach( k => {
      if (info.categories[k] == "更新情報") {
        isNews = true
      }
    })
    if (isNews) {
      news.push(info)
    }
  })
  initVue()
  bootstrap()
}, (e) => {
  initVue()
  bootstrap()
})

function initVue() {
  Vue.directive('scroll', {
    inserted: function (el, binding) {
      let f = function (evt) {
        if (binding.value(evt, el)) {
          window.removeEventListener('scroll', f)
        }
      };
      window.addEventListener('scroll', f)
    }
  });
  
  Vue.use(VueScrollTo, {
    duration: 500,
    easing: "ease-out",
    offset: -50,
    force: true,
    cancelable: true,
    onStart: false,
    onDone: false,
    onCancel: false,
    x: false,
    y: true
  });
  
  Vue.use(VueAwesomeSwiper);
  smoothscroll.polyfill();
  
}

// bootstrap()

//-----------------------------------------------------
//bootstrap
async function bootstrap() {
  var path = window.location.pathname

  for (var i = 0; i < pages.length; i++) {
    let b = pages[i]
    let reg = new RegExp(b.path)
    if (reg.test(path)) {
      for (var j = 0; j < b.entry.length; j++) {
        if (!await b.entry[j]()) {
          break
        }
      }
      break
    }
  }
  window.initFunction = window.initFunction || []
  window.initFunction.forEach((f)=>{
    f()
  })
}

//-----------------------------------------------------
//Page Functions
function pageTop() {
  return new Promise((resolve, reject)=>{
    var vue = new Vue({
      el: '#nx-app',
      data() {return {
        config: NEXCO_CONFIG,
        news: news,
        informations: informations,
      }},
      mixins: [VUE_COMMON, PAGE_TOP]
    })
    resolve(true)
  })
}
function pageStatic() {
  return new Promise((resolve, reject)=>{
    var vue = new Vue({
      el: '#nx-app',
      data() {return {
        config: NEXCO_CONFIG,
        informations: informations,
      }},
      mixins: [VUE_COMMON,]
    })
    resolve(true)
  })
}
function pageGraph() {
  return new Promise((resolve, reject)=>{
    var vue = new Vue({
      el: '#nx-app',
      data() {return {
        config: NEXCO_CONFIG,
        informations: informations,
      }},
      mixins: [VUE_COMMON,PAGE_GRAPH]
    })
    resolve(true)
  })
}
function pagePrediction() {
  return new Promise((resolve, reject)=>{
    var vue = new Vue({
      el: '#nx-app',
      data() {return {
        config: NEXCO_CONFIG,
        informations: informations,
      }},
      mixins: [VUE_COMMON,PAGE_PREDICTION]
    })
    resolve(true)
  })
}

function pageFaq() {
  return new Promise((resolve, reject)=>{
    var vue = new Vue({
      el: '#nx-app',
      data() {return {
        config: NEXCO_CONFIG,
        informations: informations,
      }},
      mixins: [VUE_COMMON, PAGE_FAQ]
    })
    resolve(true)
  })
}
function pageUseful() {
  return new Promise((resolve, reject)=>{
    var vue = new Vue({
      el: '#nx-app',
      data() {return {
        config: NEXCO_CONFIG,
        informations: informations,
      }},
      mixins: [VUE_COMMON, PAGE_USEFUL]
    })
    resolve(true)
  })
}
function pageWork() {
  return new Promise((resolve, reject)=>{
    var vue = new Vue({
      el: '#nx-app',
      data() {return {
        config: NEXCO_CONFIG,
        informations: informations,
      }},
      mixins: [VUE_COMMON, PAGE_WORK]
    })
    resolve(true)
  })
}
function pageWorkDetail() {
  return new Promise((resolve, reject)=>{
    var vue = new Vue({
      el: '#nx-app',
      data() {return {
        config: NEXCO_CONFIG,
        informations: informations,
      }},
      mixins: [VUE_COMMON, PAGE_WORK_DETAIL]
    })
    resolve(true)
  })
}
function pageNews() {
  return new Promise((resolve, reject)=>{
    var vue = new Vue({
      el: '#nx-app',
      data() {return {
        config: NEXCO_CONFIG,
        news:news,
        informations: informations,
      }},
      mixins: [VUE_COMMON, PAGE_NEWS]
    })
    resolve(true)
  })
}
function pageNewsDetail() {
  return new Promise((resolve, reject)=>{
    var vue = new Vue({
      el: '#nx-app',
      data() {return {
        config: NEXCO_CONFIG,
        informations: informations,
      }},
      mixins: [VUE_COMMON, PAGE_NEWS_DETAIL]
    })
    resolve(true)
  })
}
